import styled from 'styled-components';

const TextLabelStroke = styled.label`
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: normal;
	line-height: normal;
	color: white;
	text-shadow:
		1px 0 0 rgba(0, 0, 0, 0.5),
		0 1px 0 rgba(0, 0, 0, 0.5),
		-1px 0 0 rgba(0, 0, 0, 0.5),
		0 -1px 0 rgba(0, 0, 0, 0.5);
	user-select: none;
`;

const TextLabelStrokeRoboto = styled.label`
	font-family: 'Roboto';
	font-style: normal;
	font-weight: normal;
	line-height: normal;
	color: white;
	text-shadow: 1px 1px 0px #000000;
	user-select: none;
`;

export { TextLabelStroke, TextLabelStrokeRoboto };
